import React, { useState, useEffect } from 'react';
import GuestBar from "../../components/GuestInfo/GuestBar";
import {
  Breadcrumbs,
  Container, FormControl, FormControlLabel,
  Grid, ListItem, Paper, Radio, RadioGroup,
  Typography,
} from "@mui/material";
import {getStepFromUrl} from "../../utils/utils";
import "../../components/Booking/DayTripBooking/datePicker.scss";
import { makeStyles } from "@mui/styles";
import ActivityCard from "../../components/Booking/DayTripBooking/ActivityCard";
import {getActivityList} from "../../redux/actions/activitiesActions";
import {setTotalActivitiesFH} from "../../redux/actions/totalActions";
import {useDispatch, useSelector} from "react-redux";
import Itinerary from "../../components/Booking/DayTripBooking/Itinerary";
import {setStep} from "../../redux/actions/stepActions";
import Summary from "../../components/Booking/DayTripBooking/Summary";
import DayTripStepper from "../../components/Booking/DayTripBooking/DayTripStepper";
import {setBookingType} from "../../redux/actions/tripActions";
const useStyles = makeStyles((theme) => ({
  sectionTitle: {
    fontSize: '1.6rem',
    fontWeight: '600',
    marginBottom: '10px',
  },
  formSection: {
    marginBottom: '20px',
  },
  root:{
    maxWidth: 900,
    margin:'auto',
    padding: 10,
  },
}));

const DayTripBookingPage = ({history}) => {
  const activities = useSelector(state => state.activities);
  const {extra:selectedExtras} = useSelector(state => state.transactions);
  const bookingType = useSelector(state => state.bookingType);
  const dispatch = useDispatch();
  const classes = useStyles();

  useEffect(() => {

    dispatch(getActivityList())
        .then(() => {
          dispatch(setTotalActivitiesFH());
        });
  }, []);

  useEffect(() => {
    const stepNum = getStepFromUrl(history.location.pathname);
    dispatch(setStep(stepNum));
  }, []);

  const setBooking = (e) => {
    const type = e.target.value;
    dispatch(setBookingType(type));
  };
  // const getAllActivities = async () => {
  //   const { data } = await requestApi(`/get-activity-list`, 'get');
  //   setActivities(data);
  // };


  return (
      <>
        <GuestBar>
          <Breadcrumbs aria-label="breadcrumb" separator={'>'}>
            <Typography color="text.primary">Day Trip Bookings</Typography>
          </Breadcrumbs>
        </GuestBar>
        <Container maxWidth="lg" className={'tripInfoDetails'}>
          <DayTripStepper/>
          <div style={{marginTop: 50}}/>
          <Grid container>
            <Grid item sm={12} md={9} xs={12} className={classes.root}>

                {(Object.keys(activities.extra).length > 0) && (
                    <>
                      {Object.values(activities.extra).map((activity) => (
                            <ActivityCard
                                key={activity.id}
                                activity={activity}
                                addOrRemove={1}
                            />
                      ))}
                    </>
                )}

            </Grid>
            <Grid item sm={12} md={3} xs={12}>
              {/*<Paper style={{marginBottom: 10}}>
                <Button color={'primary'} variant={'contained'} fullWidth onClick={goToNextStep}>
                  Next Step
                </Button>
                <Button color={'secondary'} variant={'contained'} fullWidth onClick={goBack}>
                  Go Back to {prevStep.label}
                </Button>
              </Paper>*/}
              <Itinerary removable={true}/>
              <Paper style={{marginTop: 10}}>
                <ListItem alignItems={"center"} style={{justifyContent: 'center', margin: 0, padding: 15}}>
                  <FormControl component="fieldset" className={'bookingOptions'}>
                    <RadioGroup aria-label="typeBooking" name="typeBooking" value={bookingType}
                                onChange={setBooking}>
                      <FormControlLabel value="pay" control={<Radio color="default"/>} label="Book Now"
                                        style={{fontSize: 20}}/>
                      <Typography color="textSecondary" variant="body2"
                                  style={{marginLeft: 33, fontSize: '1.3rem'}}>
                        Invoice to your account or pay now by credit card
                      </Typography>
                      <FormControlLabel value="hold" control={<Radio color="default"/>}
                                                                                                     label="Hold" style={{fontSize: 20}}/>
                        <Typography color="textSecondary" variant="body2"
                                    style={{marginLeft: 33, fontSize: '1.3rem'}}>
                          Let us hold your booking for 72 hours, no questions asked
                        </Typography>
                    </RadioGroup>
                  </FormControl>
                </ListItem>
              </Paper>
              <Summary/>
            </Grid>
          </Grid>
        </Container>

      </>
  );
};

export default DayTripBookingPage;
